import { dnevniRitem } from "@/mocks/dnevniRitem";

export default function Rhythm() {
  return (
    <section id="ritem" className="scroll-mt-24 bg-background-50 py-16 md:py-24 lg:py-28">
      <div className="section-shell">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
          <div className="reveal">
            <div className="flex items-center gap-4">
              <span className="font-label text-[10px] font-semibold tracking-[0.2em] text-accent-700">
                04
              </span>
              <span className="rule-line" />
              <span className="eyebrow text-secondary-600">Dnevni ritem</span>
            </div>

            <h2 className="headline mt-5 max-w-[420px] text-[31px] text-foreground-950 sm:mt-6 sm:text-[39px] lg:text-[46px]">
              Dan pri nas
              <span className="block italic text-secondary-600">teče počasi.</span>
            </h2>

            <p className="lead mt-6 max-w-[380px]">
              Ni treba, da je obisk načrtovan. Nekateri pridejo za pet minut,
              drugi ostanejo celo popoldne — oba ritma sta dobrodošla.
            </p>

            <div className="mt-9 max-w-[400px] overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="flex items-center justify-between gap-3 border-b border-background-300/70 px-4 py-3.5 sm:px-6 sm:py-4">
                <p className="font-label text-[10px] font-semibold uppercase tracking-[0.2em] text-secondary-600">
                  Odpiralni čas
                </p>
                <span className="flex items-center gap-1.5 font-label text-[9px] uppercase tracking-[0.14em] text-foreground-500">
                  <i className="ri-time-line text-[13px] text-accent-600" />
                  Vsak dan
                </span>
              </div>

              <div className="px-4 py-5 sm:px-6">
                <div className="flex flex-col gap-1 border-b border-dashed border-background-300/80 pb-4 sm:flex-row sm:items-baseline sm:justify-between sm:gap-4">
                  <div>
                    <p className="font-heading text-[19px] leading-tight text-foreground-950 sm:text-[21px]">
                      Ponedeljek – četrtek
                    </p>
                    <p className="mt-1 font-label text-[9px] uppercase tracking-[0.16em] text-foreground-400">
                      Delavnik
                    </p>
                  </div>
                  <p className="whitespace-nowrap font-label text-[14px] font-semibold tracking-[0.04em] text-foreground-950">
                    06.00 – 22.00
                  </p>
                </div>

                <div className="mt-4 flex flex-col gap-1 border-b border-dashed border-background-300/80 pb-4 sm:flex-row sm:items-baseline sm:justify-between sm:gap-4">
                  <div>
                    <p className="font-heading text-[19px] leading-tight text-foreground-950 sm:text-[21px]">
                      Petek in sobota
                    </p>
                    <p className="mt-1 font-label text-[9px] uppercase tracking-[0.16em] text-accent-700">
                      Podaljšano
                    </p>
                  </div>
                  <p className="whitespace-nowrap font-label text-[14px] font-semibold tracking-[0.04em] text-foreground-950">
                    06.00 – 24.00
                  </p>
                </div>

                <p className="mt-4 flex items-center gap-2 font-label text-[9px] uppercase tracking-[0.16em] text-foreground-400">
                  <span className="h-1 w-1 rounded-full bg-foreground-400" />
                  Nedelja: 07.00 – 20.00
                </p>
              </div>
            </div>
          </div>

          <ol className="reveal relative ml-1 border-l border-dashed border-background-400/70">
            {dnevniRitem.map((item, index) => (
              <li key={item.id} className="group relative pb-9 pl-7 last:pb-0 sm:pb-11 sm:pl-8">
                <span className="absolute -left-[5px] top-[9px] h-[9px] w-[9px] rounded-full bg-accent-500 ring-4 ring-background-50 transition-colors duration-500 group-hover:bg-secondary-500" />

                <div className="flex items-center justify-between gap-4">
                  <span className="font-label text-[10px] font-semibold uppercase tracking-[0.2em] text-foreground-500">
                    {item.cas}
                  </span>
                  <span className="font-label text-[9px] tracking-[0.2em] text-background-500 transition-colors duration-500 group-hover:text-accent-700">
                    0{index + 1}
                  </span>
                </div>

                <h3 className="mt-2 font-heading text-[26px] leading-tight text-foreground-950 transition-colors duration-500 group-hover:text-secondary-700 sm:text-[30px]">
                  {item.naslov}
                </h3>

                <p className="mt-2 max-w-[440px] text-[14px] leading-[1.8] text-foreground-600">
                  {item.opis}
                </p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}